import Config from './DataSubjectTicketConfig'
import Details from './DataSubjectTicketDetails'
import Main from './DataSubjectTicketMain'

export default {
  Config,
  Details,
  Main,
}
